import { Component, DestroyRef, EventEmitter, inject, Inject, OnInit, Optional, Output, Self } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, NgControl } from '@angular/forms';
import { combineLatest } from 'rxjs';
import { tap } from 'rxjs/operators';
import { APP_CONFIG } from '../../../app.config';
import { AssistantPopoverService } from '../../../common/assistant-popover.service';
import { ValidationService } from '../../../common/validation.service';
import { AppConfig } from '../../../models/config/app-config';
import { VisumErfassungSubFormComponent } from '../visum-erfassung-sub-form/visum-erfassung-sub-form.component';
import { createReisekostenForm, getCheckboxesForAntragstellerLebensunterhalt, getCheckboxesForDritteLebensunterhalt } from './reisekosten.factory';

@Component({
  selector: 'app-reisekosten',
  templateUrl: './reisekosten.component.html',
  styleUrls: ['./reisekosten.component.scss']
})
export class ReisekostenComponent extends VisumErfassungSubFormComponent implements OnInit {

  @Output()
  public andereValueChanged = new EventEmitter<boolean>();
  private readonly destroyRef = inject(DestroyRef);

  checkboxesForAntragstellerLebensunterhalt = null;
  checkboxesForDritteLebensunterhalt = null;
  constructor(fb: FormBuilder,
              protected validationService: ValidationService,
              assistantPopoverService: AssistantPopoverService,
              @Inject(APP_CONFIG) protected appConfig: AppConfig,
              @Optional() @Self() controlDir: NgControl) {
    super(controlDir, assistantPopoverService);

    this.form = createReisekostenForm(fb, validationService);
    this.checkboxesForAntragstellerLebensunterhalt = getCheckboxesForAntragstellerLebensunterhalt(this.form);
    this.checkboxesForDritteLebensunterhalt = getCheckboxesForDritteLebensunterhalt(this.form);
  }

  ngOnInit() {
    super.ngOnInit();
    this.createSubscriptionsForValuesChange();
  }

  createSubscriptionsForValuesChange() {
    this.isDritteChangeHandler();
    this.isAntragstellerChangeHandler();
    this.organisationAndEinladerChangeHandler();
    this.sonstigesAndDritteSonstigesChangeHandler();
  }

  isDritteChangeHandler() {
    this.form.get("isDritte").valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef),
      tap(value => {
        if (!value) {
          this.form.get("organisation").patchValue(false);
          this.form.get("einlader").patchValue(false);
        }
      })).subscribe();
  }

  isAntragstellerChangeHandler() {
    this.form.get("isAntragsteller").valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    )
    .subscribe((value) => {
      if (!value) {
        this.form.get("bar").patchValue(false);
        this.form.get("reiseschecks").patchValue(false);
        this.form.get("kreditkarten").patchValue(false);
        this.form.get("unterkunft").patchValue(false);
        this.form.get("befoerderung").patchValue(false);
        this.form.get("sonstiges").patchValue(false);
        this.form.get("sonstigesText").patchValue(null);
      }
    });
  }

  organisationAndEinladerChangeHandler() {
    combineLatest([
      this.form.get("organisation").valueChanges,
      this.form.get("einlader").valueChanges
    ])
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(([v1, v2])  => {
      if (!v1 && !v2) {
        this.form.get("dritteBar").patchValue(false);
        this.form.get("dritteUnterkunft").patchValue(false);
        this.form.get("dritteVollstaendigeKostenuebernahme").patchValue(false);
        this.form.get("dritteBefoerderung").patchValue(false);
        this.form.get("dritteSonstiges").patchValue(false);
        this.form.get("dritteSonstigesText").patchValue(null);
      }
    });
  }

  sonstigesAndDritteSonstigesChangeHandler() {
    combineLatest([
      this.form.get("sonstiges").valueChanges,
      this.form.get("dritteSonstiges").valueChanges
    ])
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(([sonstiges, dritteSonstiges]) => {
      if (!sonstiges) {
        this.form.get("sonstigesText").patchValue(null);
        this.form.get("sonstigesText").disable();
      } else {
        this.form.get("sonstigesText").enable();
        this.form.get("sonstigesText").markAsDirty();
      }

      if (!dritteSonstiges) {
        this.form.get("dritteSonstigesText").patchValue(null);
        this.form.get("dritteSonstigesText").disable();
      } else {
        this.form.get("dritteSonstigesText").enable();
        this.form.get("dritteSonstigesText").markAsDirty();
      }
    });
  }

  public toggleAndereValueChanged(event: any): void {
    this.andereValueChanged.emit((event.target as HTMLInputElement).checked);
  }
}


